
import { Component, Prop, Vue } from 'vue-property-decorator'


/**
 * @prop name 标题
 * @prop decs 描述
*/
@Component({
    name: 'TableHeader'
})
export default class extends Vue {
    @Prop({ required: false }) private name!: string 
    @Prop({ required: true }) private decs!: string 
}
